import { Directive, Pipe, PipeTransform } from '@angular/core';
import { AbstractControl,  NG_VALIDATORS,  ValidationErrors,  Validator } from '@angular/forms';
@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchKey: string, keys: string[]): any[] {
    if (!items || !searchKey || !keys?.length) {
      return items;
    }
    const value = searchKey.toLowerCase().trim();
    return items.filter((item) =>
      keys.some((key) => item[key]?.toString().toLowerCase().includes(value)),
    );
  }
}
@Directive({
  selector: '[appPhoneNumberValidation]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PhoneNumberValidationDirective,
      multi: true,
    },
  ],
})
export class PhoneNumberValidationDirective implements Validator {
  validate(c: AbstractControl): ValidationErrors | null {
    const value = c.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return /^09/.test(String(value)) ? null : { mobilePhoneNumberWrong: true };
  }
}
